module.exports = __webpack_public_path__ + "images/arrow-up-white.6a8d7971d5f3bba9bb9033d26b3b73cc.svg";